import { useCallback } from "react";
import { useKeycloak } from "@react-keycloak/web";

import { addPassThroughKeys } from "src/services/passThroughKey";

import { usePassThroughKeys } from "./usePassThroughKeys";

export const useLogout = () => {
  const passThroughKeys = usePassThroughKeys();
  const { keycloak } = useKeycloak();

  const logout = useCallback(async () => {
    const hasPassThroughKeys = Object.values(passThroughKeys).some((value) => value.length > 0);

    if (hasPassThroughKeys) {
      keycloak.logout({
        redirectUri: `${window.location.origin}${addPassThroughKeys("/signin", passThroughKeys)}`
      });
    } else {
      keycloak.logout({
        redirectUri: `${window.location.origin}/signin`
      });
    }

    // @ts-expect-error missing type definitions, but window.PasswordCredential is valid in Chrome
    if (window.PasswordCredential) {
      const credential = await window.navigator.credentials?.get?.();

      if (credential) {
        // prevent the user from being automatically signed back in if we have saved the password
        // see https://web.dev/security-credential-management/#sign-out
        await navigator.credentials?.preventSilentAccess?.();
      }
    }
  }, [keycloak, passThroughKeys]);

  return logout;
};
